import { GET_USERS, CREATE_POST, SET_CHAT_REQUESTS_STORY_ID, SIGN_IN, GOOGLE_ID, STORY_AUTH, SET_NOT_REGISTER_STORY } from './constants'

export const initialState = {
  users: [],
  posts: [],
  user: null,
  googleId: null,
  storyAuth: {
    openLogin: false,
    storyId: '',
    createChat: false,
  },
  chatStoryId: '',
  notRegisterStory: {
    type: '',
    storyId: '',
  },
}

export const reducer = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
  case GET_USERS:
    return { ...state, users: payload }
  case SIGN_IN:
    return { ...state, user: payload }
  case GOOGLE_ID:
    return { ...state, googleId: payload }
  case STORY_AUTH:
    return { ...state, storyAuth: payload }
  case CREATE_POST:
    return {
      ...state,
      posts: [
        ...state.posts,
        { ...payload, id: Date.now() },
      ],
    }
  case SET_CHAT_REQUESTS_STORY_ID:
    return { ...state, chatStoryId: payload }
  case SET_NOT_REGISTER_STORY:
    return { ...state, notRegisterStory: payload }
  default:
    return state
  }
}
